"use client";

const CookieTriggerButton = () => {
  return (
    <button
      type="button"
      onClick={() => (window as Window & { openAxeptioCookies?: () => void }).openAxeptioCookies?.()}
      className="focus-visible:ring-dark-primary/50 ring-offset-2 outline-none focus-visible:ring-2"
    >
      Cookies
    </button>
  );
};

export default CookieTriggerButton;
